import { render, staticRenderFns } from "./WritingWords.vue?vue&type=template&id=7354ea78&scoped=true&"
import script from "./WritingWords.vue?vue&type=script&lang=js&"
export * from "./WritingWords.vue?vue&type=script&lang=js&"
import style0 from "./WritingWords.vue?vue&type=style&index=0&id=7354ea78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354ea78",
  null
  
)

export default component.exports